@if (chartOptions             &&
     chartOptions.chart       &&
     chartOptions.fill        &&
     chartOptions.dataLabels  &&
     chartOptions.legend      &&
     chartOptions.plotOptions &&
     chartOptions.series      &&
     chartOptions.tooltip     &&
     chartOptions.xaxis       &&
     chartOptions.yaxis
    ) {
  <div id="chart">
    <apx-chart #simActivityChart
      [chart]="chartOptions.chart"
      [dataLabels]="chartOptions.dataLabels"
      [fill]="chartOptions.fill"
      [legend]="chartOptions.legend"
      [plotOptions]="chartOptions.plotOptions"
      [series]="chartOptions.series"
      [tooltip]="chartOptions.tooltip"
      [xaxis]="chartOptions.xaxis"
      [yaxis]="chartOptions.yaxis"
    ></apx-chart>
  </div>
}
